


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/node-libs-browser/mock/empty.js
// module id = 789
// module chunks = 2